/**
 * Created by portiz on 2/18/19.
 */
import React from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import {Col, Row, Button, Input} from 'reactstrap';
import LoaderFullWindow from '../loader-windows/loader-full-window';
/** Multiple Language imports **/
import {Translate} from "react-localize-redux";
/** End of Multiple Language imports **/
import ApiCalls from "../../custom-classes/api-calls";
import PaginationCustom from './pagination';
import DataTable from './datatable';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import DatePicker from '../date-picker/date-picker-recent';
import SelectorRoles from '../selectors/selector-roles';
import moment from 'moment';

/**
 * Data table to handle the users
 */
class UsersDataTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            subscriptionId : null,
            username: null,
            email: null,
            phone: null,
            firstName: null,
            lastName: null,
            status: null,
            planId: null,
            loading: false,
            roleId: props.roleId ? props.roleId : null,
            hideRoleSelected: props.roleId ? true : false,
            dateFrom: null,
            dateTo: null,
            createdDateFrom: null,
            createdDateTo: null,
            createdAt: moment(),
            currentPage: 1,
            limiter: 10,
            totalPages: 1,
            headerOptions: [
                {key: "0", name: <Translate id="users-datatable.user-id"/>},
                {key: "1", name: <Translate id="users-datatable.username"/>},
                {key: "2", name: <Translate id="users-datatable.first-name"/>},
                {key: "3", name: <Translate id="users-datatable.last-name"/>},
                {key: "4", name: <Translate id="users-datatable.email"/>},
                {key: "5", name: <Translate id="users-datatable.phone-number"/>},
                {key: "6", name: <Translate id="users-datatable.role"/>},
                {key: "7", name: <Translate id="users-datatable.city"/>},
                {key: "8", name: <Translate id="users-datatable.state"/>},
                {key: "9", name: <Translate id="users-datatable.country"/>},
                {key: "10", name: <Translate id="users-datatable.last-session"/>},
                {key: "11", name: <Translate id="users-datatable.status"/>},
                {key: "12", name: <Translate id="users-datatable.created-at"/>}
            ],
            data: []
        };
        this.doSearch = this.doSearch.bind(this);
        this.convertDataToDataTable = this.convertDataToDataTable.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
        this.filter = this.filter.bind(this);
        this.handleUserIdChange = this.handleUserIdChange.bind(this);
        this.handleUsernameChange = this.handleUsernameChange.bind(this);
        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleRoleChange = this.handleRoleChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.saveToDate = this.saveToDate.bind(this);
        this.saveFromDate = this.saveFromDate.bind(this);
        this.saveCreatedToDate = this.saveCreatedToDate.bind(this);
        this.saveCreatedFromDate = this.saveCreatedFromDate.bind(this);
    }

    componentWillReceiveProps(props){
        if(props.redoSearch)
            this.doSearch();
    }

    componentDidMount(){
        // Call data
        this.doSearch();
    }

    handleStatusChange(e){
        this.setState({
            status: e === '' ? null : e
        });
    }

    handleRoleChange(e){
        this.setState({
            roleId: e === '' ? null : e
        });
    }

    handleEmailChange(e){
        this.setState({
            email: e.target.value
        });
    }

    handlePhoneChange(e){
        this.setState({
            phone: e.target.value
        });
    }

    handleUserIdChange(e){
        this.setState({
            userId: e.target.value
        });
    }

    handleUsernameChange(e){
        this.setState({
            username: e.target.value
        });
    }

    handleFirstNameChange(e){
        this.setState({
            firstName: e.target.value
        });
    }

    handleLastNameChange(e){
        this.setState({
            lastName: e.target.value
        });
    }

    handlePageClick(e){
        this.setState({
            currentPage: e
        },()=>{
            this.doSearch();
        });
    }

    filter(){
        this.doSearch();
    }

    handleRowClick(e){
        this.props.updateParent(e);
    }

    convertDataToDataTable(dataToConvert){

        this.setState({
            data: []
        },()=>{
            let newArray = [];

            for(let i=0; i < dataToConvert.length; i++)
            {
                newArray.push({
                    UserId: dataToConvert[i].UserId,
                    Username: dataToConvert[i].Username,
                    GivenName: dataToConvert[i].FullName.GivenName,
                    Surname: dataToConvert[i].FullName.Surname,
                    Email: dataToConvert[i].Email,
                    Phone: dataToConvert[i].Phone,
                    Role: dataToConvert[i].Roles[0].RoleName,
                    City: dataToConvert[i].Address.City,
                    State: dataToConvert[i].Address.State,
                    Country: dataToConvert[i].Address.Country,
                    LastSession: dataToConvert[i].LastSession,
                    Status: dataToConvert[i].Status.StatusDesc,
                    CreatedAt: dataToConvert[i].CreatedAt,
                    value: dataToConvert[i].UserId
                });
            }
            this.setState({
                data: newArray
            });
        });

    }

    /**
     * Call the results to display
     */
    doSearch() {
        this.setState({
            loading: true
        });

        let apiCall = ApiCalls.getUsersAdvanced(
            this.state.userId,
            this.state.username,
            this.state.firstName,
            this.state.lastName,
            this.state.phone,
            this.state.email,
            this.state.roleId,
            this.state.dateFrom,
            this.state.dateTo,
            this.state.createdDateFrom,
            this.state.createdDateTo,
            this.state.currentPage,
            this.state.limiter,
            false
        );

        apiCall.then((data)=> {

            this.setState({
                loading: false,
                totalPages: data.PageTotals,
                data: []
            },()=>{
                if(data.UserInfo !== null)
                    this.convertDataToDataTable(data.UserInfo);
            });
        });
    }

    saveFromDate = (field) => (newValue)=>{
        this.setState({dateFrom: newValue.date});
    };

    saveToDate = (field) => (newValue)=>{
        this.setState({dateTo: newValue.date});
    };

    saveCreatedFromDate = (field) => (newValue)=>{
        this.setState({createdDateFrom: newValue.date});
    };

    saveCreatedToDate = (field) => (newValue)=>{
        this.setState({createdDateTo: newValue.date});
    };


    // Render a generic modal. The body text should be sent in the text
    render() {
        return (
            <div>
                <Row>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Translate id="users-datatable.user-id"/>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Input type="text" onChange={this.handleUserIdChange} />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Translate id="users-datatable.username"/>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Input type="text" onChange={this.handleUsernameChange} />
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Translate id="users-datatable.first-name"/>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Input type="text"  onChange={this.handleFirstNameChange} />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Translate id="users-datatable.last-name"/>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Input type="text"  onChange={this.handleLastNameChange} />
                            </Col>
                        </Row>
                    </Col>
                </Row>


                <Row>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Translate id="users-datatable.email"/>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Input type="text"  onChange={this.handleEmailChange} />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Translate id="users-datatable.phone-number"/>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Input type="text"  onChange={this.handlePhoneChange} />
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row>
                    {/*<Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Translate id="users-datatable.status"/>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <SelectorStatusAccount updateParent={this.handleStatusChange}/>
                            </Col>
                        </Row>
                    </Col> /*Sorry. Removed by time */}
                    {
                        !this.state.hideRoleSelected ?
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                                <Row>
                                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                        <Translate id="users-datatable.role"/>
                                    </Col>
                                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                        <SelectorRoles roleId={this.state.roleId} updateParent={this.handleRoleChange}/>
                                    </Col>
                                </Row>
                            </Col> : null
                    }

                </Row>

                <Row>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Translate id="users-datatable.last-session-from"/>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <DatePicker data={this.state} updateParent={this.saveFromDate()}/>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Translate id="users-datatable.last-session-to"/>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <DatePicker data={this.state} updateParent={this.saveToDate()}/>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Translate id="users-datatable.created-from"/>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <DatePicker data={this.state} updateParent={this.saveCreatedFromDate()}/>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Translate id="users-datatable.created-to"/>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <DatePicker data={this.state} updateParent={this.saveCreatedToDate()}/>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Button color="success" onClick={this.filter}>
                                    <Translate id="users-datatable.filter"/>
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                    </Col>
                </Row>

                <DataTable headerOptions={this.state.headerOptions} data={this.state.data}
                           updateParent={this.handleRowClick}/>
                <PaginationCustom totalPages={this.state.totalPages}
                                  currentPage={this.state.currentPage} updateParent={this.handlePageClick} />
                {this.state.loading ? <LoaderFullWindow/> : null}
            </div>
        );
    }
}

export default UsersDataTable;